// export this package's api
import Trigger from './Trigger'
export default Trigger



// WEBPACK FOOTER //
// ./components/trigger/index.js